import { WebStorageStateStore } from 'oidc-client-ts';

/**
 * Configuración OIDC centralizada.
 * Para cambiar de proveedor (Keycloak → Azure AD) solo edita las variables
 * REACT_APP_OIDC_* en el archivo .env — el resto de la app no cambia.
 */
const oidcConfig = {
  // URL base del proveedor de identidad (authority / issuer)
  authority: process.env.REACT_APP_OIDC_AUTHORITY,

  // Client ID registrado en el IdP
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,

  // URL a la que el IdP redirige tras autenticar al usuario
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI,

  // URL a la que el IdP redirige tras el logout
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_URI,

  // Authorization Code Flow con PKCE (estándar recomendado)
  response_type: 'code',

  // Scopes mínimos necesarios; ajusta si Azure AD requiere scopes adicionales
  scope: process.env.REACT_APP_OIDC_SCOPE,

  // Renovación silenciosa del token antes de que expire
  automaticSilentRenew: true,

  // Almacenar tokens en localStorage para que la sesión persista entre recargas
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export default oidcConfig;
